import React from "react";

const Arrows = ({ onClick }) => (
  <svg
    width="183"
    height="183"
    viewBox="0 0 183 183"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="64.0073" width="54.8635" height="97.5352" rx="20" fill="#FFDAFE" />
    <rect
      x="64.0073"
      y="85.3433"
      width="54.8635"
      height="97.5352"
      rx="20"
      fill="#FFDAFE"
    />
    <rect
      className="right-arrow"
      x="182.879"
      y="64.0073"
      width="54.8635"
      height="97.5352"
      rx="20"
      transform="rotate(90 182.879 64.0073)"
      fill="#FFDAFE"
      onClick={onClick}
    />
    <rect
      x="97.5352"
      y="64.0073"
      width="54.8635"
      height="97.5352"
      rx="20"
      transform="rotate(90 97.5352 64.0073)"
      fill="#FFDAFE"
    />
    <path
      d="M86.3241 15.0149C88.1004 11.1068 93.6516 11.1068 95.4279 15.015L102.39 30.3323C103.894 33.6428 101.474 37.4012 97.8379 37.4012L83.9141 37.4012C80.2777 37.4012 77.8575 33.6428 79.3622 30.3323L86.3241 15.0149Z"
      fill="#E8A9E5"
    />
    <path
      className="right-arrow"
      d="M167.724 87.3109C171.632 89.0872 171.632 94.6384 167.724 96.4147L152.406 103.377C149.096 104.881 145.338 102.461 145.338 98.8247L145.338 84.9009C145.338 81.2645 149.096 78.8444 152.406 80.349L167.724 87.3109Z"
      fill="#D970D5"
      onClick={onClick}
    />
    <path
      d="M18.6238 96.4147C14.7157 94.6384 14.7157 89.0872 18.6238 87.3109L33.9412 80.349C37.2517 78.8443 41.0101 81.2645 41.0101 84.9009L41.0101 98.8247C41.0101 102.461 37.2517 104.881 33.9412 103.377L18.6238 96.4147Z"
      fill="#E8A9E5"
    />
    <path
      d="M95.3678 166.912C93.6105 170.878 87.9823 170.878 86.225 166.912L79.6198 152.005C78.1551 148.699 80.5754 144.979 84.1912 144.979L97.4016 144.979C101.017 144.979 103.438 148.699 101.973 152.005L95.3678 166.912Z"
      fill="#E8A9E5"
    />
  </svg>
);

export default Arrows;
